import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import AssessmentDataReport from '../../Reports/AssessmentDataReport';

export default function AssessmentDataPage(props) {
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.assessment_data')}
				category={I18n.t('admin.reports')}
			/>
			<AssessmentDataReport
				assessment_abc_endpoint={props.assessment_abc_endpoint}
				assessment_stats_endpoint={props.assessment_stats_endpoint}
				export_datatable_endpoint={props.export_datatable_endpoint}
				export_endpoint={props.export_endpoint}
				report={props.report}
			/>
		</div>
	);
}
